import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

export const Input = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'w-full border border-line bg-surface px-4 py-3 text-[15px] text-ink outline-none',
        'placeholder:text-muted-2 focus:border-accent transition-colors duration-140',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
